import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon, MinusIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-paper px-5 py-8 sm:py-16" data-id="element-89" data-mp="1hbgu4bwv3v38">
      <div className="mx-auto max-w-2xl" data-id="element-90" data-mp="1cfjfca18ywsk">
        <h2 className="text-center font-serif-display text-2xl font-bold text-ink sm:text-4xl" data-id="element-91" data-mp="1ccnd49id9lyb">
          Questions fréquentes
        </h2>

        <div className="mt-6 divide-y divide-cobalt/20 border-y border-cobalt/20 sm:mt-8" data-id="element-92" data-mp="252w14hzl30kt">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <div key={faq.question} data-id="element-93" data-mp="1v5hl2jhkodt1" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex min-h-[48px] w-full items-center justify-between gap-4 py-4 text-left" data-id="element-94" data-mp="1v4g4y0lp914g">
                  <span className="text-sm font-semibold text-ink sm:text-base" data-id="element-95" data-mp="1kors7i2c5wi1">{faq.question}</span>
                  <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-cobalt/15 text-cobalt-deep" data-id="element-96" data-mp="1plia8axpb263">
                    {isOpen ? <MinusIcon className="h-4 w-4" aria-hidden="true" data-id="element-97" data-mp="1fodm45kaowmn" /> : <PlusIcon className="h-4 w-4" aria-hidden="true" data-id="element-98" data-mp="11xihj5gtx1ov" />}
                  </span>
                </button>
                <AnimatePresence initial={false} data-id="element-99" data-mp="16piecp1lreh8">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-100" data-mp="s043fcidoozq">
                      <p className="pb-4 text-sm leading-relaxed text-ink/70" data-id="element-101" data-mp="2pmn6e1082429">{faq.answer}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}